<div class="header-container">
  <h2>Select icon</h2>
  <ng-container *ngIf="type === 'new'">
    <mat-form-field style="color: black">
      <input (keyup)="onSearchChange()" [(ngModel)]="searchValue" matInput placeholder="Search">
    </mat-form-field>
    <div (click)="changeType('normal')" [ngClass]="{active: iconType === 'normal'}" class="type-button">normal</div>
    <div (click)="changeType('contrast')" [ngClass]="{active: iconType === 'contrast'}" class="type-button">contrast</div>
    <div (click)="changeType('blank')" [ngClass]="{active: iconType === 'blank'}" class="type-button">blank</div>
  </ng-container>
</div>

<div *ngIf="type === 'new'" class="icon-container">
  <ng-container *ngFor="let icon of iconList">
  <span (click)="onSelect(icon)" [ngClass]="{'active': icon == data.active, 'icon-inner-container': true}" matTooltip="{{icon}}">
    <ibex-icon [name]="icon"></ibex-icon>
  </span>
  </ng-container>
</div>
